import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { findJob } from "../../../../common/data/jobLanding";

// Function to categorize jobs
const categorizeJobs = (jobs) => {
  const categories = {
    Development: [],
    Sales: [],
    Implementation: [],
    Support: [],
    Admin: [],
  };

  jobs.forEach((job) => {
    if (
      job.lable.toLowerCase().includes("developer") ||
      job.lable.toLowerCase().includes("frontend") ||
      job.lable.toLowerCase().includes("full stack")
    ) {
      categories.Development.push(job);
    } else if (job.lable.toLowerCase().includes("administrator")) {
      categories.Admin.push(job);
    } else if (job.lable.toLowerCase().includes("hr")) {
      categories.Sales.push(job); // Assuming HR falls under Sales for this example.
    } else if (job.lable.toLowerCase().includes("integration")) {
      categories.Implementation.push(job);
    } else if (job.lable.toLowerCase().includes("support")) {
      categories.Support.push(job);
    }
  });

  return categories;
};

const FindJob = ({ onSelectJob }) => {
  const categorizedJobs = categorizeJobs(findJob);

  return (
    <React.Fragment>
      <section className="section bg-light" id="findJob">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center mb-5">
                <h1 className="mb-3 fw-semibold lh-base">
                  Current <span className="text-primary">Job Openings</span>
                </h1>
                <p className="text-muted">
                  Connecting businesses with skilled ERP professionals is
                  simple. Post your project requirements, review qualified
                  candidates, and choose the right expert to drive your ERP
                  success.
                </p>
              </div>
            </Col>
          </Row>

          {/* Job Categories Sections */}
          {Object.keys(categorizedJobs).map((category, index) => (
            <Row key={index} className="mb-5">
              <Col lg={12}>
                <h3 className="text-center">{category} Jobs</h3>
                <Row>
                  {categorizedJobs[category].map((item, key) => (
                    <Col lg={4} key={key} className="mb-4">
                      <div className="d-flex flex-wrap gap-3">
                        <Card
                          className="shadow-lg border-light flex-grow-1"
                          style={{ minHeight: "150px" }} // Set uniform height
                        >
                          <CardBody className="d-flex flex-column">
                          <div
                              className="position-absolute top-0 end-0 bottom-1 p-2  text-muted rounded"
                              style={{
                                borderRadius: "0 0 0 8px",
                                fontSize: "0.9rem",
                                zIndex: 1,
                              }}
                            >
                              {item.jobs}
                            </div>
                            {/* Avatar and Details Section */}
                            <div className="d-flex align-items-center mb-3">
                              {/* Avatar */}
                              <div className="avatar-sm me-3 flex-shrink-0">
                                <div className="avatar-title bg-warning-subtle rounded">
                                  <img
                                    src={item.company}
                                    alt=""
                                    className="avatar-xxs"
                                    style={{
                                      maxWidth: "100%",
                                      height: "auto",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Content */}
                              <div className="flex-grow-1 overflow-hidden">
                                <Link to="#!" className="text-truncate d-block">
                                  <h5 className="mb-2 text-truncate">
                                    {item.lable}
                                  </h5>
                                </Link>
                                <div className="hstack gap-2 flex-wrap">
                                  {/* Status Badges */}
                                  <span
                                    className={
                                      "badge bg-" +
                                      item.s1[1] +
                                      "-subtle text-" +
                                      item.s1[1]
                                    }
                                  >
                                    {item.s1[0]}
                                  </span>
                                  <span
                                    className={
                                      "badge bg-" +
                                      item.s2[1] +
                                      "-subtle text-" +
                                      item.s2[1]
                                    }
                                  >
                                    {item.s2[0]}
                                  </span>
                                  {item.s3 && (
                                    <span
                                      className={
                                        "badge bg-" +
                                        item.s3[1] +
                                        "-subtle text-" +
                                        item.s3[1]
                                      }
                                    >
                                      {item.s3[0]}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Spacer to push the button to the bottom */}
                            <div className="mt-auto text-center">
                              <Link
                                to="#!"
                                className="btn btn-primary w-100"
                                onClick={() => onSelectJob(item.lable)}
                              >
                                Apply Now
                              </Link>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          ))}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default FindJob;
